export class AutocompleteOptions {
    intId: Array<any> = [];
    tailNumber: Array<any> = [];
}
